import React, { useState, useEffect } from 'react';
import logo from './crescendo-logo.png';
import rumiImg from './assets/rumi-headshot.jpg';
import foxxyImg from './assets/foxxy-headshot.jpg';
import jokerImg from './assets/joker-headshot.jpg';
import vinceImg from './assets/vince-headshot.jpg';
import jxImg from './assets/jx-headshot.jpg';
import algoImg from './assets/algorand-logo.png';
import './style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

function App() {
  const [copied, setCopied] = useState(false);
  const [ranking, setRanking] = useState("..."); 
  const [price, setPrice] = useState("...");
  const [price7d, setPrice7d] = useState("...");
  const [volume7d, setVolume7d] = useState("...");
  const [marketCap, setMarketCap] = useState("...");
  const [tvl, setTvl] = useState("...");
  const [currentCurrency, setCurrentCurrency] = useState(31566704);

  const assetId = "435335235";

  // Copy asset ID to clipboard
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(assetId); 
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    } catch (error) {
      console.error("Failed to copy asset ID:", error);
    }
  };

  // Allow for formatting numbers with a specified number of decimals
  const formatNumber = (number, decimals = 0) => {
    if (isNaN(number)) return "N/A";
    const factor = Math.pow(10, decimals);
    return Math.floor(number * factor) / factor;
  };
  
  // Fetch the price and related metrics
  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = `https://api.vestigelabs.org/assets/list?network_id=0&asset_ids=${assetId}&denominating_asset_id=${currentCurrency}&limit=50&offset=0&order_dir=desc`;
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        const results = data.results[0];
        console.log(results.name);
  
        setPrice(results.price ? formatNumber(results.price, 6) : "N/A");
        setPrice7d(results.price7d ? formatNumber(results.price7d, 9) : "N/A");
        setVolume7d(results.volume7d ? formatNumber(results.volume7d, 2) : "N/A");
        setMarketCap(results.market_cap ? formatNumber(results.market_cap) : "N/A");
        setTvl(results.tvl ? formatNumber(results.tvl) : "N/A");
        setRanking(results.rank ? formatNumber(results.rank) : "N/A");
      } catch (error) {
        console.error("Error fetching data:", error);
        setPrice("--");
        setPrice7d("--");
        setVolume7d("--");
        setMarketCap("--");
        setTvl("--");
        setRanking("--");
      }
    };
  
    fetchData();
    
    if (process.env.NODE_ENV === "production") {
      const interval = setInterval(fetchData, 60000);
      return () => clearInterval(interval);
    }

  }, [assetId, currentCurrency]);
  

  // Toggle currency between ALGO and USD
  const toggleCurrency = () => {
    setCurrentCurrency((prev) => (prev === 31566704 ? 0 : 31566704));
  };

  return (
    <div id="main">
      <header id="header-main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="logo">
                <img src={logo} alt="Crescendo logo" />
                <h1>Connect, Collaborate, Create</h1>
              </div>
              <div className="card-content">
                <p>Crescendo is dedicated to amplifying musicians by cultivating opportunities to connect, collaborate, and&nbsp;create.</p>
                <div className="social-cta">
                  <span>FOLLOW US AND GET IN THE MIX</span>
                  <a href="https://x.com/Crescendo_ASA" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                  <a href="https://discord.gg/NCWKJbVz2G" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDiscord} /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="content-main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div id="crsd">
                <h2>$CRSD</h2>
                <div className="copy-asset">
                  <div className="copy">Asset ID: {assetId}
                    <button
                      onClick={handleCopy}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "inherit",
                      }}
                      title="Copy Asset ID"
                    >
                      <FontAwesomeIcon icon={faCopy} />
                    </button>
                    {copied && <span className="copied">Copied!</span>}
                  </div>
                </div>
                <p>$CRSD is a membership token for creators to connect with new audiences and cultivate their community, in an environment that creates opportunity for collaboration.</p>
                <div className="stat-section">
                  <div className="stat-block">
                    <strong>Price</strong>
                    <p>
                      {currentCurrency === "USD" ? `$${price}` : `${price} ALGO`}
                    </p>
                  </div>
                  <div className="stat-block">
                    <strong>Marketcap</strong>
                    <p>
                      {currentCurrency === "USD"
                        ? `$${Number(marketCap).toLocaleString()}`
                        : `${Number(marketCap).toLocaleString()} ALGO`}
                    </p>
                  </div>
                  <div className="stat-block">
                    <strong>TVL</strong>
                    <p>
                      {currentCurrency === "USD"
                        ? `$${Number(tvl).toLocaleString()}`
                        : `${Number(tvl).toLocaleString()} ALGO`}
                    </p>
                  </div>
                  <div className="stat-block">
                    <strong>7d Change</strong>
                    <p>
                      {(() => {
                        const priceNow    = Number(price);
                        const priceBefore = Number(price7d);

                        // guard against bad data or divide by zero
                        const priceChange =
                            isNaN(priceNow) || isNaN(priceBefore) || priceBefore === 0
                            ? NaN
                            : ((priceNow - priceBefore) / priceBefore) * 100;

                        // if it’s not a number, show “N/A”
                        if (isNaN(priceChange)) {
                            return <>N/A</>;
                        }

                        const sign = priceChange >= 0 ? "+" : "–";
                        return (
                          <>{sign}{Math.abs(priceChange).toFixed(2)}%</>
                        );
                      })()}
                    </p>
                  </div>
                  <div className="stat-block">
                    <strong>Volume (7d)</strong>
                    <p>
                      {currentCurrency === 31566704
                        ? `$${Number(volume7d).toLocaleString()}`
                        : `${Number(volume7d).toLocaleString()} ALGO`}
                    </p>
                  </div>
                  <div className="stat-block">
                    <strong>Vestige Rank</strong>
                    <p>{ranking}</p>
                  </div>
                </div>
                <button
                  className={`btn ${currentCurrency === "USD" ? "btn-primary toggle" : "btn-disabled toggle"}`}
                  onClick={() => toggleCurrency("USD")}
                  disabled={currentCurrency === "USD"}
                >
                  USD
                </button>
                <span className="currency-pipe">|</span>
                <button
                  className={`btn ${currentCurrency === "ALGO" ? "btn-primary toggle" : "btn-disabled toggle"}`}
                  onClick={() => toggleCurrency("ALGO")}
                  disabled={currentCurrency === "ALGO"}
                >
                  ALGO
                </button>
                <a className="anchor-link" href="https://vestige.fi/asset/435335235" target="_blank" rel="noreferrer">View on Vestige</a>
              </div>
            </div>
            <div className="col-12">
              <div id="tokenomics">
                <div className="card-content">
                  <h2>Vibenomics</h2>
                  <p className="tokenomics-headline">$CRSD is fully distributed, with a total supply&nbsp;of&nbsp;1.5B</p>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <p className="big-number">42%</p>
                      <p className="supply-title">Circulating</p>
                      <p>[621MM]</p>
                    </div>
                    <div className="col-12 col-sm-4">
                      <p className="big-number">54%</p>
                      <p className="supply-title">Burned</p>
                      <p>[810MM]</p>
                    </div>
                    <div className="col-12 col-sm-4">
                      <p className="big-number">4%</p>
                      <p className="supply-title">Treasury</p>
                      <p>[69MM]</p>
                    </div>
                  </div>
                  <a className="anchor-link" href="https://allo.info/asset/435335235/token" target="_blank" rel="noreferrer">View token info</a> | <a className="anchor-link" href="https://allo.info/account/B4FRQFLHOSCCF7US472YINIMN3356CHRSTGNPGOH4B6UCOY3IIAW6C6RCA" target="_blank" rel="noreferrer">View treasury wallet</a>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div id="forte">
                <h2>Forte Members</h2>
                <p className="forte-headline">Featuring some of our most creative, active, and engaged community members.</p>
                <ul className="member-list list-unstyled">
                  <li className="d-flex align-items-start mb-4">
                    <img src={rumiImg} className="me-3" alt="Rumi"  />
                    <div>
                      <h5 className="mt-0 mb-1">Rumi</h5>
                      <p>Rumi is a published songwriter and musician from Texas. His finance career led to a curiosity in blockchain. In 2022, Rumi assumed management of Crescendo.</p>
                      <p>His passions for music, finance, and blockchain culminated on Algorand. Music featured on Astro Explorer, Goodbois, & Rxelms. Published works include <a href="https://album.link/i/1614980992" target="_blank" rel="noreferrer">Inner&nbsp;Child</a> & <a href="https://album.link/i/1600374927" target="_blank" rel="noreferrer">Headspins</a>.</p>
                      <p className="member-links">LINKS: <a href="https://open.spotify.com/artist/7nipa8jHQ9EMsmaOcFtTRr?si=Tfh8espVTK2x1-N7F4bVXw" target="_blank" rel="noreferrer">Spotify</a>, <a href="https://music.apple.com/us/artist/love-rumi/1472297752" target="_blank" rel="noreferrer">Apple Music</a>, <a href="https://soundcloud.com/loverumi" target="_blank" rel="noreferrer">Soundcloud</a>, <a href="https://www.instagram.com/loverumi.art/"  target="_blank" rel="noreferrer">Instagram</a>, <a href="https://x.com/loverumi_art" target="_blank" rel="noreferrer">Twitter/X</a></p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start mb-4">
                    <img src={foxxyImg} className="me-3" alt="ExtraFoxxy"  />
                    <div>
                      <h5 className="mt-0 mb-1">ExtraFox</h5>
                      <p>Born and raised in the Pacific Northwest, Extrafox is an OG Algorand creator with an accomplished reputation in both the NFT and token ecosystem. A multifaceted artist, Extrafox blends music, 3D design, illustration, and video production into their creative process.</p>
                      <p>Beyond their artistic endeavors, Extrafox is integral to community management, fostering collaboration, and promoting innovation within the Algorand ecosystem. As a passionate collector and investor, they channel their appreciation for the arts into every project they pursue.</p>
                      <p className="member-links">LINKS: <a href="https://linktr.ee/extrafox" target="_blank" rel="noreferrer">Linktree</a>, <a href="https://www.youtube.com/channel/UCgRzsBVnmLsNS1S7vKZwDYw" target="_blank" rel="noreferrer">YouTube</a>, <a href="https://x.com/EFoxAJ" target="_blank" rel="noreferrer">Twitter/X</a></p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start mb-4">
                    <img src={jokerImg} className="me-3" alt="MrJoker" />
                    <div>
                      <h5 className="mt-0 mb-1">MrJoker</h5>
                      <p>Mr Joker is born and raised in the sunshine state of Florida. Inspired by the Hip Hop culture of the 80s and 90s, the Ghettoblaster NFT project was born. The project follows an evolution of art from pixel art, to handdrawn Ghettoblaster boomboxes, with some 3D animations thrown in between.</p>
                      <p>Even more rare, are the Ghettoblaster pieces with short music loops attached to them. In an effort to inspire the uninspired, the Ghettoblaster NFTs containing music loops document my journey of learning to produce music from scratch. Free commercial use rights are available for any music box NFT holder to use, or sample, in their own music endeavors.</p>
                      <p className="member-links">LINKS: <a href="https://linktr.ee/ghettoblaster" target="_blank" rel="noreferrer">Linktree</a>, <a href="https://soundcloud.com/ghettoblasternft" target="_blank" rel="noreferrer">Soundcloud</a>, <a href="https://x.com/Joker42356" target="_blank" rel="noreferrer">Twitter/X</a></p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start mb-4">
                    <img src={vinceImg} className="me-3" alt="Vince" />
                    <div>
                      <h5 className="mt-0 mb-1">Vince</h5>
                      <p>Hailing from Philadelphia, Pennsylvania, Vince is a developer, designer, artist, and musician. He has contributed his dev skills to several Algorand projects such as <a href="https://astroexplorer.co" target="_blank" rel="noreferrer">Astro&nbsp;Explorer</a>, <a href="https://woopalgo.com" target="_blank" rel="noreferrer">Woop</a>, <a href="https://wen.tools" target="_blank" rel="noreferrer">wen.tools</a>, and <a href="#main">Crescendo</a>.</p>
                      <p>His music has been featured on several mediums, including multiple vinyl records with <a href="https://faroutfangtooth.bandcamp.com/" target="_blank" rel="noreferrer">Far Out Fangtooth</a>. He also creates experimental music videos for local record labels and bands, and sometimes just for fun.</p>
                      <p className="member-links">LINKS: <a href="https://www.youtube.com/@VinceAlvare" target="_blank" rel="noreferrer">YouTube</a>, <a href="https://soundcloud.com/vincealvare" target="_blank" rel="noreferrer">Soundcloud</a>, <a href="https://giphy.com/channel/themoonandvenus" target="_blank" rel="noreferrer">Giphy</a>, <a href="https://x.com/AlgoVince" target="_blank" rel="noreferrer">Twitter/X</a></p>
                    </div>
                  </li>
                  <li className="d-flex align-items-start mb-4">
                    <img src={jxImg} className="me-3" alt="MrJoker" />
                    <div>
                      <h5 className="mt-0 mb-1">J(X)</h5>
                      <p>Having grown up in Oxnard, California, J(X) comes from a diverse musical background that ranged from his days in punk, metal and post hardcore bands he grew up playing in to the hip hop jazz and funk sound of his immediate family and friends.</p>
                      <p>J(X) established his range and consistency by completing campaigns like "12tapesin12months", "100days100beats", and "1stnthe15th", and he continues to deliver his art to the public.</p>
                      <p className="member-links">LINKS: <a href="https://jxoxbeats.gumroad.com/" target="_blank" rel="noreferrer">Gumroad</a>, <a href="https://solo.to/j-x" target="_blank" rel="noreferrer">Solo.to</a>, <a href="https://www.instagram.com/j.x.beats" target="_blank" rel="noreferrer">Instagram</a>, <a href="https://x.com/jx_oxbeats?s=09(x" target="_blank" rel="noreferrer">Twitter/X</a></p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12">
              <div id="tokens">
                <div className="card-content">
                  <h2>Community Tokens</h2>
                  <p>Brought to you by some of the OGs in the Crescendo community.</p>
                  <a className="btn btn-primary" href="https://vestige.fi/asset/753890862" target="_blank" rel="noreferrer">Prisms</a>
                  <a className="btn btn-primary" href="https://vestige.fi/asset/1255493254" target="_blank" rel="noreferrer">BoomBox</a>
                  <a className="btn btn-primary" href="https://vestige.fi/asset/1387094911" target="_blank" rel="noreferrer">Rowdy</a>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div id="algorand">
                <a href="https://algorand.co/" target="_blank" rel="noreferrer"><img src={algoImg} alt="Algorand" /></a>
                <p>Powered by Algorand</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer id="footer-main">
        <div className="container">
          <div className="col-12">
            <div className="socials">
              <a href="https://x.com/Crescendo_ASA" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
              <a href="https://discord.gg/NCWKJbVz2G" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDiscord} /></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
